export const HIDE_MIGRATED_SHARED_LINK_INFO_KEY = 'vdr-hide-migrated-shared-link-info-key';
